import { render } from "./otherBank.vue?vue&type=template&id=3f1d7946&scoped=true"
import script from "./otherBank.vue?vue&type=script&lang=js"
export * from "./otherBank.vue?vue&type=script&lang=js"

import "./otherBank.vue?vue&type=style&index=0&id=3f1d7946&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1d7946"]])

export default __exports__